/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import BaseResponse from '../model/BaseResponse';
import MissionControllerDtoBasicAccountInfoListRequest from '../model/MissionControllerDtoBasicAccountInfoListRequest';
import MissionControllerDtoBasicAccountInfoListResponse from '../model/MissionControllerDtoBasicAccountInfoListResponse';
import MissionControllerDtoBasicAccountPointLogListRequest from '../model/MissionControllerDtoBasicAccountPointLogListRequest';
import MissionControllerDtoBasicAccountPointLogListResponse from '../model/MissionControllerDtoBasicAccountPointLogListResponse';
import MissionControllerDtoBasicGradeRewardLogListRequest from '../model/MissionControllerDtoBasicGradeRewardLogListRequest';
import MissionControllerDtoBasicGradeRewardLogListResponse from '../model/MissionControllerDtoBasicGradeRewardLogListResponse';
import MissionControllerDtoBasicInvitedUsersListRequest from '../model/MissionControllerDtoBasicInvitedUsersListRequest';
import MissionControllerDtoBasicInvitedUsersListResponse from '../model/MissionControllerDtoBasicInvitedUsersListResponse';
import MissionControllerDtoMissionFreeInfoCreateRequest from '../model/MissionControllerDtoMissionFreeInfoCreateRequest';
import MissionControllerDtoMissionFreeInfoDetailRequest from '../model/MissionControllerDtoMissionFreeInfoDetailRequest';
import MissionControllerDtoMissionFreeInfoDetailResponse from '../model/MissionControllerDtoMissionFreeInfoDetailResponse';
import MissionControllerDtoMissionFreeInfoListRequest from '../model/MissionControllerDtoMissionFreeInfoListRequest';
import MissionControllerDtoMissionFreeInfoListResponse from '../model/MissionControllerDtoMissionFreeInfoListResponse';
import MissionControllerDtoMissionFreeInfoUpdateRequest from '../model/MissionControllerDtoMissionFreeInfoUpdateRequest';

/**
* PerplayMission service.
* @module api/PerplayMissionApi
* @version 1.0
*/
export default class PerplayMissionApi {

    /**
    * Constructs a new PerplayMissionApi. 
    * @alias module:api/PerplayMissionApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the apiPerplayMissionBasicAccountInfoListPost operation.
     * @callback module:api/PerplayMissionApi~apiPerplayMissionBasicAccountInfoListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MissionControllerDtoBasicAccountInfoListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MissionControllerDtoBasicAccountInfoListRequest} [missionControllerDtoBasicAccountInfoListRequest] 
     * @param {module:api/PerplayMissionApi~apiPerplayMissionBasicAccountInfoListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MissionControllerDtoBasicAccountInfoListResponse}
     */
    apiPerplayMissionBasicAccountInfoListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['missionControllerDtoBasicAccountInfoListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = MissionControllerDtoBasicAccountInfoListResponse;
      return this.apiClient.callApi(
        '/api/PerplayMission/BasicAccountInfoList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayMissionBasicAccountPointLogListPost operation.
     * @callback module:api/PerplayMissionApi~apiPerplayMissionBasicAccountPointLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MissionControllerDtoBasicAccountPointLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MissionControllerDtoBasicAccountPointLogListRequest} [missionControllerDtoBasicAccountPointLogListRequest] 
     * @param {module:api/PerplayMissionApi~apiPerplayMissionBasicAccountPointLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MissionControllerDtoBasicAccountPointLogListResponse}
     */
    apiPerplayMissionBasicAccountPointLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['missionControllerDtoBasicAccountPointLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = MissionControllerDtoBasicAccountPointLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayMission/BasicAccountPointLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayMissionBasicGradeRewardLogListPost operation.
     * @callback module:api/PerplayMissionApi~apiPerplayMissionBasicGradeRewardLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MissionControllerDtoBasicGradeRewardLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MissionControllerDtoBasicGradeRewardLogListRequest} [missionControllerDtoBasicGradeRewardLogListRequest] 
     * @param {module:api/PerplayMissionApi~apiPerplayMissionBasicGradeRewardLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MissionControllerDtoBasicGradeRewardLogListResponse}
     */
    apiPerplayMissionBasicGradeRewardLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['missionControllerDtoBasicGradeRewardLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = MissionControllerDtoBasicGradeRewardLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayMission/BasicGradeRewardLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayMissionBasicInvitedUsersListPost operation.
     * @callback module:api/PerplayMissionApi~apiPerplayMissionBasicInvitedUsersListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MissionControllerDtoBasicInvitedUsersListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MissionControllerDtoBasicInvitedUsersListRequest} [missionControllerDtoBasicInvitedUsersListRequest] 
     * @param {module:api/PerplayMissionApi~apiPerplayMissionBasicInvitedUsersListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MissionControllerDtoBasicInvitedUsersListResponse}
     */
    apiPerplayMissionBasicInvitedUsersListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['missionControllerDtoBasicInvitedUsersListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = MissionControllerDtoBasicInvitedUsersListResponse;
      return this.apiClient.callApi(
        '/api/PerplayMission/BasicInvitedUsersList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayMissionMissionFreeInfoCreatePost operation.
     * @callback module:api/PerplayMissionApi~apiPerplayMissionMissionFreeInfoCreatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MissionControllerDtoMissionFreeInfoCreateRequest} [missionControllerDtoMissionFreeInfoCreateRequest] 
     * @param {module:api/PerplayMissionApi~apiPerplayMissionMissionFreeInfoCreatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayMissionMissionFreeInfoCreatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['missionControllerDtoMissionFreeInfoCreateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayMission/MissionFreeInfoCreate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayMissionMissionFreeInfoDetailPost operation.
     * @callback module:api/PerplayMissionApi~apiPerplayMissionMissionFreeInfoDetailPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MissionControllerDtoMissionFreeInfoDetailResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MissionControllerDtoMissionFreeInfoDetailRequest} [missionControllerDtoMissionFreeInfoDetailRequest] 
     * @param {module:api/PerplayMissionApi~apiPerplayMissionMissionFreeInfoDetailPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MissionControllerDtoMissionFreeInfoDetailResponse}
     */
    apiPerplayMissionMissionFreeInfoDetailPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['missionControllerDtoMissionFreeInfoDetailRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = MissionControllerDtoMissionFreeInfoDetailResponse;
      return this.apiClient.callApi(
        '/api/PerplayMission/MissionFreeInfoDetail', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayMissionMissionFreeInfoListPost operation.
     * @callback module:api/PerplayMissionApi~apiPerplayMissionMissionFreeInfoListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MissionControllerDtoMissionFreeInfoListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MissionControllerDtoMissionFreeInfoListRequest} [missionControllerDtoMissionFreeInfoListRequest] 
     * @param {module:api/PerplayMissionApi~apiPerplayMissionMissionFreeInfoListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MissionControllerDtoMissionFreeInfoListResponse}
     */
    apiPerplayMissionMissionFreeInfoListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['missionControllerDtoMissionFreeInfoListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = MissionControllerDtoMissionFreeInfoListResponse;
      return this.apiClient.callApi(
        '/api/PerplayMission/MissionFreeInfoList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayMissionMissionFreeInfoUpdatePost operation.
     * @callback module:api/PerplayMissionApi~apiPerplayMissionMissionFreeInfoUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MissionControllerDtoMissionFreeInfoUpdateRequest} [missionControllerDtoMissionFreeInfoUpdateRequest] 
     * @param {module:api/PerplayMissionApi~apiPerplayMissionMissionFreeInfoUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayMissionMissionFreeInfoUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['missionControllerDtoMissionFreeInfoUpdateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayMission/MissionFreeInfoUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
